<template>
  <div class="widget-row" :style="style">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'WidgetRow',
  props: {
    gridTemplateColumns: String,
    flexGrow: String
  },
  data: function() {
    return {
      numberOfSlotChildren: 0
    }
  },
  computed: {
    style() {
      return {
        gridTemplateColumns: this.gridTemplateColumns,
        flexGrow: this.flexGrow
      }
    }
  },
}
</script>

<style>
.widget-row {
  /* display: grid;
  grid-template-rows: 1fr;
  gap: 0px 0px;
  grid-template-areas: ". . . . ."; */
  margin-bottom: 20px;
}
.widget-row > div {
  margin-right: 40px;
}
.widget-row > div:last-child {
  flex-grow: 1;
  margin-right: 0;

}
</style>
